import StaBar from 'dc/StaBar';
import styled from 'styled-components';

export const StatusBar = styled(StaBar)`
  background-color: #d32e2e;

  span {
    flex: 1;
  }
`;
